import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpLoaderService, SnackbarService } from '@tymes4-shared';
import { TranslateService } from '@ngx-translate/core';
import { MollieOnboardingInformationDTO, PaymentServiceProviderService, DashboardOnboardingLinkModel } from '../../api';

@Component({
    selector: 'app-mollie-onboarding-form',
    templateUrl: './mollie-onboarding-form.component.html',
    styleUrls: ['./mollie-onboarding-form.component.scss'],
    standalone: false
})
export class MollieOnboardingFormComponent implements OnInit {

  public form!: FormGroup;
  public saving = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public passedData: any,
    public dialogRef: MatDialogRef<MollieOnboardingFormComponent>,
    private paymentServiceProviderService: PaymentServiceProviderService,
    private loader: HttpLoaderService,
    private snackBar: SnackbarService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.form = new FormGroup({
      Email: new FormControl('', [Validators.required, Validators.email]),
      FirstName: new FormControl('', [Validators.required]),
      LastName: new FormControl('', [Validators.required]),
      OrganizationLegalName: new FormControl('', [Validators.required]),
      CountryIsoCode: new FormControl('NL')
    });
  }

  save() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.saving = true;
    const formData: MollieOnboardingInformationDTO = this.form.value;

    this.paymentServiceProviderService.getMollieOnboardingLink(formData).subscribe({
      next: (response: DashboardOnboardingLinkModel) => {
        this.saving = false;
        if (response?.OnboardingLink) {
          window.open(response.OnboardingLink, '_blank');
          this.snackBar.open('Mollie onboarding link opened successfully');
          this.dialogRef.close(true);
        } else {
          this.snackBar.error('Failed to get Mollie onboarding link');
        }
      },
      error: (error: any) => {
        this.saving = false;
        this.snackBar.error('Failed to get Mollie onboarding link');
        console.error('Failed to get Mollie onboarding link', error);
      }
    });
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
